export const CameraIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.888672 4.37505C0.888672 3.46318 1.62789 2.72396 2.53976 2.72396C3.01354 2.72396 3.43417 2.42079 3.584 1.97131L3.63867 1.80729C3.66446 1.72994 3.67735 1.69127 3.69114 1.65696C3.86726 1.21887 4.27997 0.921404 4.75127 0.89286C4.78818 0.890625 4.82895 0.890625 4.91048 0.890625H9.08909C9.17062 0.890625 9.21139 0.890625 9.2483 0.89286C9.7196 0.921404 10.1323 1.21887 10.3084 1.65696C10.3222 1.69127 10.3351 1.72994 10.3609 1.80729L10.4156 1.97131C10.5654 2.42079 10.986 2.72396 11.4598 2.72396C12.3717 2.72396 13.1109 3.46318 13.1109 4.37505V9.5684C13.1109 10.5952 13.1109 11.1085 12.9111 11.5007C12.7353 11.8457 12.4548 12.1261 12.1099 12.3019C11.7177 12.5017 11.2043 12.5017 10.1776 12.5017H3.82201C2.79524 12.5017 2.28186 12.5017 1.88969 12.3019C1.54473 12.1261 1.26426 11.8457 1.08849 11.5007C0.888672 11.1085 0.888672 10.5952 0.888672 9.5684V4.37505Z"
        stroke="white"
        strokeWidth="1.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99978 9.75174C8.51857 9.75174 9.74978 8.52052 9.74978 7.00174C9.74978 5.48295 8.51857 4.25174 6.99978 4.25174C5.481 4.25174 4.24978 5.48295 4.24978 7.00174C4.24978 8.52052 5.481 9.75174 6.99978 9.75174Z"
        stroke="white"
        strokeWidth="1.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
